import React, { FC } from 'react';

import { ChevronRight } from '@assets/icons';
import { PatchedLink } from '@utils/patched-link';

import { BreadcrumbItem, Container, Name, NextArrow } from './BreadcrumbStyle';
import { BreadcrumbProps } from './BreadcrumbInterface';

const Breadcrumb: FC<BreadcrumbProps> = ({ items, className }) => (
  <Container className={className}>
    {items?.map((item, index) => (
      <BreadcrumbItem key={item.title}>
        {items.length - 1 !== index ? (
          <>
            {item?.url ? (
              <PatchedLink href={item?.url}>{item?.title}</PatchedLink>
            ) : (
              <Name>{item?.title}</Name>
            )}
            <NextArrow
              icon={ChevronRight}
              fontSize={12}
              paletteColor='grey800'
            />
          </>
        ) : (
          <Name>{item?.title}</Name>
        )}
      </BreadcrumbItem>
    ))}
  </Container>
);

export default Breadcrumb;
